<template>
    <div id="content" :class="$route.path !== '/' ? 'logged' : ''">

            <header v-if="$route.path !== '/'" id="header" class="navbar fixed-top navbar-expand-lg navbar-light">
                <nav class="container-lg flex-wrap flex-md-nowrap">
                    <div class="navbar-brand">
                        <button type="button" id="btn-back" class="btn mr-3" @click="goBack">
                            <i class="fa fa-chevron-left"></i>
                        </button>
                    </div>
                    <router-link to="/events">
                        <img id="logo"
                             :src="require('./assets/logocoesia.png')"
                             class="img-fluid ml-3" />
                    </router-link>
                    <button class="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbar"
                            aria-controls="navbar"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbar">
                        <ul class="navbar-nav mx-auto">
                            <li class="nav-item">
                                <router-link id="home" to="/events" @click="closeMenu()" class="nav-link">Home</router-link>
                            </li>
                            <li v-if="user && (user.participants || user.staff)" class="nav-item">
                                <router-link id="user" to="/profile" @click="closeMenu()" class="nav-link">Profile</router-link>
                            </li>
                            <li v-if="user && user.levelId < 3" class="nav-item">
                                <a id="admin" href="/api/admin" class="nav-link">Admin</a>
                            </li>
                            <li v-if="!testing" class="nav-item">
                                <button type="button" @click="switchOffline" class="nav-link">
                                    Go {{ offlineMode ? 'online' : 'offline' }}
                                </button>
                            </li>
                            <li class="nav-item">
                                <a href="#" id="logout" @click="logout" class="nav-link">Logout</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>

        <router-view :key="this.$route.params.id"></router-view>

        <footer class="text-center">
            <hr class="mt-0">
            <small>
                In case of technical problems or App errors, please <a href="mailto:info@coesiaevents.com">Contact us</a>!<br>
                vers. {{ appVersion }}
            </small>
        </footer>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'App',
    computed: {
        ...mapGetters([
            'user',
            'testing',
            'offlineMode',
            'apiPath',
            'appVersion',
            'fairItems',
            'token'
        ])
    },
    watch: {
        user() {
            if (this.user && !this.user.confirmed) {
                this.$router.push('/profile/confirm')
            }
        }
    },
    methods: {
        logout() {
            this.$store.dispatch("logout").then(() => {
                if (process.env.NODE_ENV === 'development') {
                    this.$router.push("/")
                } else {
                    window.top.location = this.apiPath + 'logout';
                }
            });
        },
        closeMenu() {
            var myCollapse = document.getElementById('navbar')
            myCollapse.classList.remove("show")
        },
        switchOffline() {
            this.closeMenu()
            //console.log(!this.offlineMode)
            this.$store.dispatch('offline', !this.offlineMode)
            if (!this.offlineMode) {
                this.$router.go()
            }
        },
        goBack() {
            if (window.history.state.back) {
                //console.log(this.$route.params.subpage)
                this.$router.back()
            }
        },
        updateInitialState(token) {
            console.log('updateInitialState => fairItems', this.fairItems.length)
            if (this.fairItems.length) return
            //this.$store.dispatch('checkOffline')
            Promise.all([
                this.$store.dispatch('getFairItems', token),
                this.$store.dispatch('getEventsItems', token),
                this.$store.dispatch('getContactItems', token)
            ]).then(() => {
                this.$store.dispatch('loadingData', false)
            })
        }
    },
    updated() {
        console.log("APP UPDATED - route: "+ this.$route.path)
        //const token = localStorage.getItem("token");
        if (this.$route.path == '/') {
            this.$store.dispatch('resetFairItems')
            this.$store.dispatch('loadingData', true)
        } else {
            if (this.token) {
                this.updateInitialState(this.token);
            }
        }
    },
    created() {
        /* console.log("APP CREATED - route: "+ this.$route.path)
        if (this.token) {
            this.updateInitialState(this.token);
        } */
    },
}
</script>

<style></style>
